import fiftyLogo from 'shared/static/images/logo-50skills.svg';
import styled from 'styled-components';

const locale = {
  en: {
    fiftyFooter_copyright: 'Copyright',
    fiftyFooter_poweredBy: 'Powered by',
  },
  is: {
    fiftyFooter_copyright: 'Höfundarréttur',
    fiftyFooter_poweredBy: 'Knúið af',
  },
  pl: {
    fiftyFooter_copyright: 'Prawa autorskie',
    fiftyFooter_poweredBy: 'Obsługiwane przez',
  },
  no: {
    fiftyFooter_copyright: 'Opphavsrett',
    fiftyFooter_poweredBy: 'Drevet av',
  },
  sv: {
    fiftyFooter_copyright: 'Upphovsrätt',
    fiftyFooter_poweredBy: 'Drivs av',
  },
  fr: {
    fiftyFooter_copyright: "Droits d'auteur",
    fiftyFooter_poweredBy: 'En partenariat avec',
  },
};

export default function FiftyFooter({ lang }) {
  const t = locale[lang];
  const year = new Date().getFullYear();
  return (
    <Wrapper>
      <TextContainer>
        <div>
          {t.fiftyFooter_copyright} © {year}
        </div>
        <div>{t.fiftyFooter_poweredBy} 50skills</div>
      </TextContainer>
      <a href="https://www.50skills.com" aria-label="50skills">
        <img src={fiftyLogo} alt="50skills" />
      </a>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 32px 0;
  color: hsla(240, 11%, 73%, 1);
  background-color: ${(p) => p.theme.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  text-align: center;

  > a > img {
    height: 32px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
